import axios, { AxiosInstance } from "axios";
import Cookies from "js-cookie";
import { TranslationModel } from "../translation/models/translationModel";

import { AxiosRequestConfig } from "axios";

interface ApiClient extends Omit<AxiosInstance, "get" | "post" | "put" | "delete"> {
  get<R>(url: string, config?: AxiosRequestConfig): Promise<R>;
  post<R>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R>;
  put<R>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R>;
  delete<R>(url: string, config?: AxiosRequestConfig): Promise<R>;
}

axios.interceptors.response.use(
    (response) => {
      // If the response data is a Blob, return the full response
      if (response.data instanceof Blob) {
        return response;
      }
      // Otherwise, return the response data
      return response.data;
    },
    (error) => {
      // Check if the response has a 401 status code
      if (error.response && error.response.status === 401) {
        // Redirect to the root path
        localStorage.removeItem("Session");
        window.location.href = '/account';
      }
      return Promise.reject(error);
      // Reject the promise with the error object
    
    }
);

axios.interceptors.request.use(async (config) => {
  const localStr: any = localStorage.getItem("localization");
  if (localStr) {
    const localization: TranslationModel = JSON.parse(localStr);
    config.headers.set("Accept-Language", localization.CurrentLanguage);
  } else {
    config.headers.set("Accept-Language", "ar");
  }

  if (!config.headers["Content-Type"]) {
    config.headers.set("Content-Type", "application/json");
  }

  return config;
});

export const HttpClient = {
  get: axios.get as ApiClient["get"],
  post: axios.post as ApiClient["post"],
  put: axios.put as ApiClient["put"],
  delete: axios.delete as ApiClient["delete"],
  axios: axios,
};
